import { Reducer } from 'redux';
import { PayloadAction } from '@lifesize/typescript-react-redux-utils';
import { ModalActionType, ModalProps } from '../constants/modalConstants';
import Modal from '../state/Modal';
import _get from 'lodash/get';

const modalReducer: Reducer<Modal> =
  (state = new Modal(), action: PayloadAction<string, ModalProps>) => {
    switch (action.type) {
      case ModalActionType.MODAL_OPEN:
        return state.set('modalType', action.payload.modalType).set('payload', _get(action.payload, 'payload')).set('pendingClosedModal', false);
      case ModalActionType.MODAL_CLOSE:
        const newState = state.set('modalType', undefined);
        return newState.set('pendingClosedModal', false);
      case ModalActionType.MODAL_PENDING_CLOSE:
        return state.set('pendingClosedModal', true);
      default:
        return state;
    }
  };

export default modalReducer;
